import React, { useState, useEffect, useRef } from "react"

const Image = ({ src }) => {
  const [loaded, setLoaded] = useState(false)
  const [ratio, setRatio] = useState(null)
  const [imageSrc, setImageSrc] = useState("")
  const imgRef = useRef(null)

  useEffect(() => {
    setImageSrc(src)
    if (imgRef.current) {
      imgRef.current.addEventListener("load", () => {
        
        let height = imgRef.current.clientHeight
        let width = imgRef.current.clientWidth
        let ratio = height / width
        setRatio(ratio)
        setLoaded(true)
      })
      imgRef.current.addEventListener("error", () => {
        setImageSrc("https://via.placeholder.com/300x300")
      })
    }
  }, [src])

  return (
    <>
      <img ref={imgRef} className={`ratio-${ratio > 1 ? `portrait` : `landscape`} ${loaded ? `loaded` : `not-laoded`} gallery-item__image`} src={imageSrc} />
    </>
  )
}

export default Image
